import {
  createDefaultRpcTransport,
  createSolanaRpcFromTransport,
  type RpcResponse,
  type RpcTransport,
} from '@solana/kit';

/**
 * Builds a Solana kit RPC client whose every request carries a rotating
 * `Authorization: Bearer <token>` header. The token is resolved per request via
 * `getAuthToken`, reproducing the web3.js `fetchMiddleware` auth so a single cached
 * client never sends a stale JWT. Shared by the client (`getSolanaRpc`) and server
 * (`getServerSolanaRpc`) factories; keep it free of client/server-only imports so
 * neither bundle pulls in the other's dependencies.
 */
export function createJwtAuthenticatedSolanaRpc(
  url: string,
  getAuthToken: () => string | Promise<string>,
) {
  const transport: RpcTransport = async <TResponse>(
    ...args: Parameters<RpcTransport>
  ): Promise<RpcResponse<TResponse>> => {
    const authToken = await getAuthToken();
    const authenticatedTransport = createDefaultRpcTransport({
      url,
      headers: { Authorization: `Bearer ${authToken}` },
    });
    return authenticatedTransport<TResponse>(...args);
  };

  return createSolanaRpcFromTransport(transport);
}
